import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAdminAuth } from '../../context/AdminAuthContext'
import { supabase } from '../../utils/supabase'
import { LockClosedIcon } from '@heroicons/react/24/solid'

const AdminLogin = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { adminLogin, loading, isAdmin } = useAdminAuth()

  useEffect(() => {
    // Admin login sayfasına geldiğinde normal kullanıcı session'ını temizle
    const clearNormalUserSession = async () => {
      try {
        // Supabase session'ını temizle (normal kullanıcı için)
        await supabase.auth.signOut()
        console.log('Normal user session cleared for admin login')
      } catch (error) {
        console.log('Session clear error (expected):', error)
      }
    }

    clearNormalUserSession()

    // Zaten giriş yapmış admin kullanıcıyı kontrol et
    if (isAdmin()) {
      navigate('/admin')
    }
  }, [isAdmin, navigate])

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')

    const { success, error } = await adminLogin(email, password)
    
    if (success) {
      navigate('/admin')
    } else {
      setError(error || 'Giriş yapılırken bir hata oluştu')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-indigo-100">
            <LockClosedIcon className="h-6 w-6 text-indigo-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Admin Paneli Girişi
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Mobilya E-ticaret Admin Paneli
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleLogin}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                E-posta adresi
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="E-posta adresi"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Şifre
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Şifre"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="text-sm text-red-700">{error}</div>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </div>

          <div className="text-center">
            <p className="text-sm text-gray-600">
              Geçerli admin hesabınızla giriş yapın
            </p>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AdminLogin 